import Routes from './route-constants';
import { secureRouteBuilder } from '../secure-route';
import { mapStateToNotificationsCount } from './store-state';
import {
    getServiceRequestFlags,
    loadApplicationAccessRole
} from '@telstra-connect/service-requests/feature-flags/load-flags';
import { ApplicationName } from '@telstra-connect/service-requests/activity-tracking';
import { ViewRequestList } from './pages/view-request-list/index-lazy';
import { ViewRequestDetails } from './pages/view-request-details/index-lazy';
import { ViewDeviceDetails } from './pages/view-device-details/index-lazy';
import { NewRequest } from './pages/new-request/index-lazy';
import { Modifications } from './pages/modifications/index-lazy';
import { DeviceDetails } from './pages/device-detail/index-lazy';
import { FncServiceListLandingPage } from './pages/feature-network-change/fnc-products-landing-page/index-lazy';
import { CreateNewRequestForm } from './pages/mobile-plans-devices/components/feature-change-request/index-lazy';
import { CreateFncRequest } from './pages/feature-network-change/basic-form/index-lazy';
import { NBNDiagnostics } from './pages/nbn-diagnostics/index-lazy';
import { YpsCatalogue } from './pages/yps-catalogue-page/index-lazy';
import {
    MaximQuestionComponentForGeneralRequest
} from './pages/maxim-request-form/general-requests-question-component-lazy';
import { YPSRequestForm } from './pages/yps-request-form/index-lazy';
import { AllRequests } from './pages/view-request-list/all-requests-lazy';
import Card from './components/card-handler/index-lazy';
import { NBNHistory } from './pages/nbn-diagnostics/pages/history-detail-page/index-lazy';
import { NBNToastComponent } from './pages/nbn-diagnostics/components/toast-notification';
import { MaximDetails } from './pages/maxim-detail-page/index-lazy';
import { UnifiedTrackView } from './pages/unified-track-view/index-lazy';
import { Activity, GetDisplayName } from '@utils';
import { IApplicationDefinition, IAppRegistry, Routing } from '@apps-config';
import { headerName } from '@telstra-connect/service-requests/helpers/common-static-data';
import { navigateType } from '@utils/withRouterWrapper';
import global from '@applications'
import RequestListRedirection from './pages/view-request-list/component/redirection-component/redirection-component';
import { ViewInternetProductDetails } from './pages/internet-products/internet-product-details/index-lazy';
import { ViewInternetProductDNSDetails } from './pages/internet-products/internet-product-dns-details/index-lazy';
import GeneralRequestMaximToTnowRoute from './pages/maxim-request-form/general-request-maxim-to-tnow-route';
import YPSLandingHome from './pages/yps-landing-home';

const routes = new Routing.RoutesHelper({
    rootPath: secureRouteBuilder(Routes.Open),
    subpagesPathMask: secureRouteBuilder(Routes.ServiceRequests),
});
export const serviceRequestTrackRoute = routes.getAppPath();
export const yourProductAndServicesRoute = routes.getPageSubpath(
    Routes.Modifications
);
export const applicationName = ApplicationName;
const notificationsCount: (state) => number = mapStateToNotificationsCount;
const tracker = Activity.createTracker(applicationName);

export const Application: IApplicationDefinition = {
    get applicationName() {
        return applicationName;
    },
    get acceptsUserFeedback() {
        return true;
    },
    get acceptsErrorReports() {
        return true;
    },
    get card() {
        return Card;
    },
    get unifiedTrackView() {
        return UnifiedTrackView;
    },
    get tracker() {
        return tracker;
    },
    get routes() {
        return routes;
    },
    get nbnToastComponent() {
        return NBNToastComponent;
    },
    init(registry: IAppRegistry, availableToUser: boolean) {
        if (availableToUser) {
            registry.add(Application);
        }
    },
    render() {
        const generalRequestRoute = getServiceRequestFlags().featureFlags
            .tedig7456GeneralRequestMaximToTnow
            ? {
                path: routes.getPageSubpath(Routes.ypsMobilitySolutionsURL),
                component: MaximQuestionComponentForGeneralRequest,
            }
            : {
                path: routes.getPageSubpath(Routes.ypsMaximFormPageURL),
                component: MaximQuestionComponentForGeneralRequest,
            };
        return [
            {
                path: routes.getPageSubpath(Routes.NewRequest),
                component: NewRequest,
            },
            {
                path: routes.getPageSubpath(Routes.Modifications),
                component: Modifications,
            },
            {
                path: routes.getPageSubpath(Routes.viewRequestRouteFromYPSPage),
                component: ViewRequestDetails,
            },
            {
                path: routes.getPageSubpath(Routes.ViewStrategicRequestRoute),
                component: ViewRequestDetails,
            },
            {
                path: routes.getPageSubpath(Routes.ViewInternetProductRoute),
                component: ViewInternetProductDetails,
            },
            {
                path: routes.getPageSubpath(Routes.ViewRequestRoute),
                component: ViewRequestDetails,
            },
            {
                path: routes.getPageSubpath(Routes.DeviceDetails),
                component: DeviceDetails,
            },
            {
                path: routes.getPageSubpath(Routes.Devices),
                component: ViewDeviceDetails,
            },
            {
                path: routes.getPageSubpath(
                    Routes.maximFormFromMobileServicesPage
                ),
                component: GeneralRequestMaximToTnowRoute,
            },
            {
                path: routes.getPageSubpath(
                    Routes.mobilitySolutionsFromMobileServicesPage
                ),
                component: MaximQuestionComponentForGeneralRequest,
            },
            {
                path: routes.getPageSubpath(Routes.mobileChangeRequestForm),
                component: CreateNewRequestForm,
            },
            {
                path: routes.getPageSubpath(Routes.FNCForm),
                component: CreateFncRequest,
            },
            {
                path: routes.getPageSubpath(Routes.servicesListFNC),
                component: FncServiceListLandingPage,
            },
            {
                path: routes.getPageSubpath(Routes.ViewHistoryRoute),
                component: NBNHistory,
            },
            {
                path: routes.getPageSubpath(Routes.NBNDiagnostics),
                component: NBNDiagnostics,
            },
            {
                path: routes.getPageSubpath(Routes.ypsFormPageURL),
                component: YPSRequestForm,
            },
            {
                path: routes.getPageSubpath(Routes.ypsCataloguePageURL),
                component: YpsCatalogue,
            },
            {
                path: routes.getPageSubpath(Routes.ypsLandingPageURL),
                component: YPSLandingHome,
            },
            {
                path: routes.getPageSubpath(Routes.maximFormURL),
                component: GeneralRequestMaximToTnowRoute,
            },
            {
                path: routes.getPageSubpath(Routes.mobilitySolutionsURL),
                component: MaximQuestionComponentForGeneralRequest,
            },
            {
                path: routes.getPageSubpath(Routes.maximDetailPage),
                component: MaximDetails,
            },
            {
                path: routes.getPageSubpath(Routes.allRequestsListPageURL),
                component: AllRequests,
            },
            {
                path: Routes.OpenRequestRouteV6,
                component: RequestListRedirection,
            },
            {
                path: Routes.ClosedRequestRouteV6,
                component: RequestListRedirection,
            },
            {
                path: routes.getAppPath(),
                component: ViewRequestList,
            },
            {
                path: routes.getPageSubpath(Routes.ViewInternetProductDnsRoute),
                component: ViewInternetProductDNSDetails,
            },
            ...[generalRequestRoute]
        ];
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    menuItem<IServiceRequestsAppState>(state, navigate: navigateType) {
        const viewAggregatedYPSpage =
            state.serviceRequests.featureFlagsData.data.viewAggregatedYPSpage;
        const aggregatedViewForLegacySC =
            getServiceRequestFlags().featureFlags.aggregatedViewForLegacySC
        const SiteMenuFeatureFlag = global.applications.Platform && global.applications.Platform.sideMenu;
        const applicationAccessRole = loadApplicationAccessRole();
        if (SiteMenuFeatureFlag) {
            if (applicationAccessRole) {
                return [
                    {
                        testID: 'ui-menu-requests',
                        name: 'Submit',
                        intialPagePath: routes.getInitialPagePath(),
                        appPath: routes.getAppPath(),
                        onClick: () => {
                            Application.tracker.trackMenu('Submit');
                        },
                        subMenus: [
                            {
                                name: 'Request or change',
                                active: false,
                                icon: '',
                                onClick: () => {
                                    if (viewAggregatedYPSpage) {
                                        Application.tracker.trackMenu('Submit:Request or change');
                                        return (
                                            navigate(
                                                routes.getPageSubpath(Routes.ypsLandingPageURL)))
                                    } else {
                                        Application.tracker.trackMenu('Submit:Request or change');
                                        return (
                                            navigate(
                                                routes.getPageSubpath(Routes.Modifications)))
                                    }
                                }
                            }]
                    },
                    {
                        testID: 'ui-menu-requests',
                        name: 'Track',
                        intialPagePath: routes.getInitialPagePath(),
                        appPath: routes.getAppPath(),
                        onClick: () => {
                            Application.tracker.trackMenu('Track');
                        },
                        subMenus: [
                            {
                                name: 'Requests',
                                active: false,
                                icon: '',
                                onClick: () => {
                                    if (viewAggregatedYPSpage ||
                                        (aggregatedViewForLegacySC && !viewAggregatedYPSpage)) {
                                        Application.tracker.trackMenu('Track:Requests');
                                        return (
                                            navigate(routes.getPageSubpath(
                                                Routes.allRequestsListPageURL))
                                        )
                                    } else {
                                        Application.tracker.trackMenu('Track:Requests');
                                        return (
                                            navigate((routes.getInitialPagePath()))
                                        )
                                    }
                                }
                            }]
                    },
                    {
                        testID: 'ui-menu-productservices',
                        name: GetDisplayName(applicationName),
                        intialPagePath: viewAggregatedYPSpage ?
                            routes.getPageSubpath(Routes.ypsLandingPageURL) :
                            routes.getPageSubpath(Routes.Modifications),
                        appPath: routes.getAppPath(),
                        onClick: () => {
                            Application.tracker.trackMenu(GetDisplayName(applicationName));
                        },
                    },
                ];
            } else if (!applicationAccessRole && viewAggregatedYPSpage) {
                return [
                    {
                        testID: 'ui-menu-requests',
                        name: 'Submit',
                        intialPagePath: routes.getInitialPagePath(),
                        appPath: routes.getAppPath(),
                        onClick: () => {
                            Application.tracker.trackMenu('Submit');
                        },
                        subMenus: [
                            {
                                name: 'Request or change',
                                active: false,
                                icon: '',
                                onClick: () => {
                                    if (viewAggregatedYPSpage) {
                                        Application.tracker.trackMenu('Submit:Request or change');
                                        return (
                                            navigate(
                                                routes.getPageSubpath(Routes.ypsLandingPageURL)))
                                    } else {
                                        Application.tracker.trackMenu('Submit:Request or change');
                                        return (
                                            navigate(
                                                routes.getPageSubpath(Routes.Modifications)))
                                    }
                                }
                            }]
                    },
                    {
                        testID: 'ui-menu-requests',
                        name: 'Track',
                        intialPagePath: routes.getInitialPagePath(),
                        appPath: routes.getAppPath(),
                        onClick: () => {
                            Application.tracker.trackMenu(
                                headerName.requestHeader
                            );
                        },
                        subMenus: [
                            {
                                name: 'Requests',
                                active: false,
                                icon: '',
                                onClick: () => {
                                    Application.tracker.trackMenu('Track:Requests');
                                    return (
                                        navigate(routes.getPageSubpath(
                                            Routes.allRequestsListPageURL)))
                                },
                            },
                        ],
                    },
                    {
                        testID: 'ui-menu-productservices',
                        name: GetDisplayName(applicationName),
                        intialPagePath: viewAggregatedYPSpage ?
                            routes.getPageSubpath(Routes.ypsLandingPageURL) :
                            routes.getPageSubpath(Routes.Modifications),
                        appPath: routes.getAppPath(),
                        onClick: () => {
                            Application.tracker.trackMenu(
                                headerName.requestHeader
                            );
                        },
                    },
                ];
            } else {
                return [
                    {
                        testID: 'ui-menu-requests',
                        name: 'Submit',
                        intialPagePath: routes.getInitialPagePath(),
                        appPath: routes.getAppPath(),
                        onClick: () => {
                            Application.tracker.trackMenu('Submit');
                        },
                        subMenus: [
                            {
                                name: 'Request or change',
                                active: false,
                                icon: '',
                                onClick: () => {
                                    if (viewAggregatedYPSpage) {
                                        Application.tracker.trackMenu('Submit:Request or change');
                                        return (
                                            navigate(
                                                routes.getPageSubpath(Routes.ypsLandingPageURL)))
                                    } else {
                                        Application.tracker.trackMenu('Submit:Request or change');
                                        return (
                                            navigate(
                                                routes.getPageSubpath(Routes.Modifications)))
                                    }
                                }
                            }]
                    },
                    {
                        testID: 'ui-menu-requests',
                        name: 'Track',
                        intialPagePath: routes.getInitialPagePath(),
                        appPath: routes.getAppPath(),
                        onClick: () => {
                            Application.tracker.trackMenu('Track');
                        },
                        subMenus: [
                            {
                                name: 'Requests',
                                active: false,
                                icon: '',
                                onClick: () => {
                                    if (viewAggregatedYPSpage ||
                                        (aggregatedViewForLegacySC && !viewAggregatedYPSpage)) {
                                        Application.tracker.trackMenu(`Track:${headerName.requestHeader}`);
                                        return (
                                            navigate(routes.getPageSubpath(
                                                Routes.allRequestsListPageURL)))
                                    } else {
                                        Application.tracker.trackMenu(`Track:${headerName.requestHeader}`);
                                        return (
                                            navigate(routes.getInitialPagePath()))
                                    }
                                },
                            },
                        ],
                    },
                ];
            }
        } else {
            return [
                {
                    testID: 'ui-menu-requests',
                    name: GetDisplayName(applicationName),
                    intialPagePath: viewAggregatedYPSpage ?
                        routes.getPageSubpath(Routes.ypsLandingPageURL) :
                        routes.getPageSubpath(Routes.Modifications),
                    appPath: routes.getAppPath(),
                    notificationsCount: notificationsCount(state),
                    onClick: () => {
                        Application.tracker.trackMenu(headerName.requestHeader);
                    },
                },
            ];
        }
    },
};
export { Routes };
